// extracted by mini-css-extract-plugin
export default {"prview":"style_prview__V-Tu9","ic_badge":"style_ic_badge__NsODu","overlay":"style_overlay__ENwyc","prview_inner":"style_prview_inner__BHRb3"};